import script from "./RouteHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteHandler.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__